export type MonthMessages = {
  januaryLabel: string;
  februaryLabel: string;
  marchLabel: string;
  aprilLabel: string;
  mayLabel: string;
  juneLabel: string;
  julyLabel: string;
  augustLabel: string;
  septemberLabel: string;
  octoberLabel: string;
  novemberLabel: string;
  decemberLabel: string;
};

export const MONTH_MESSAGES: MonthMessages = {
  januaryLabel: "Janeiro",
  februaryLabel: "Fevereiro",
  marchLabel: "Março",
  aprilLabel: "Abril",
  mayLabel: "Maio",
  juneLabel: "Junho",
  julyLabel: "Julho",
  augustLabel: "Agosto",
  septemberLabel: "Setembro",
  octoberLabel: "Outubro",
  novemberLabel: "Novembro",
  decemberLabel: "Dezembro",
};
